import type { ReferralSource } from '../enums'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface ReferralSourceReturn {
  mode: ComputedRef<InputMode>
  label: string
  setReferralSource: (value: ReferralSource) => void
}

export const useReferralSource = (): ReferralSourceReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'How did you hear about us?'

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && tutorApplicationStore.getReferralSource === null))

  const setReferralSource = (value: ReferralSource): void => {
    tutorApplicationStore.setReferralSource(value)
  }

  return {
    mode,
    label,
    setReferralSource,
  }
}
